import { render, staticRenderFns } from "./NewAssessment.vue?vue&type=template&id=70a66d7e"
import script from "./NewAssessment.vue?vue&type=script&lang=js"
export * from "./NewAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports